// Утилиты для работы с зонами доставки

// Города по умолчанию для центрирования карты
export const DEFAULT_CITIES: Record<string, [number, number]> = {
  Рязань: [54.6292, 39.737],
  Калуга: [54.5138, 36.2612],
}

// Парсинг area в координаты
// Поддерживает форматы: Schedex (lat,lon|lat,lon|...), GeoJSON, WKT
export const parseAreaToCoordinates = (area: string): number[][][] | null => {
  if (!area || area === 'null' || area === 'undefined') {
    return null
  }

  // Формат 1: Кастомный формат Schedex (lat,lon|lat,lon|...)
  if (area.includes('|') && area.includes(',')) {
    try {
      const coords = area.split('|').map(pair => {
        const [lat, lon] = pair.trim().split(',').map(Number)
        return [lat, lon]
      })
      // Проверяем что все координаты валидны
      if (coords.every(c => !isNaN(c[0]) && !isNaN(c[1]))) {
        return [coords]
      }
    } catch {
      // Продолжаем с другими форматами
    }
  }

  try {
    // Пробуем GeoJSON
    const geoJson = JSON.parse(area)
    if (geoJson.type === 'Polygon') {
      return [geoJson.coordinates[0].map((coord: number[]) => [coord[1], coord[0]])]
    }
    if (geoJson.type === 'Feature' && geoJson.geometry?.type === 'Polygon') {
      return [geoJson.geometry.coordinates[0].map((coord: number[]) => [coord[1], coord[0]])]
    }
  } catch {
    // Пробуем WKT
    if (area.startsWith('POLYGON')) {
      const match = area.match(/\(\(([^)]+)\)\)/)
      if (match) {
        const coords = match[1].split(',').map(pair => {
          const [lon, lat] = pair.trim().split(' ').map(Number)
          return [lat, lon]
        })
        return [coords]
      }
    }
  }
  return null
}
